import { Capacitor } from "@capacitor/core";
import { Home, PanelLeft, Compass, BookOpen, Camera } from "lucide-react";

// Barre de navigation fixe en bas, mobile uniquement (masquee des `lg` par
// App.css, meme seuil que le tiroir). Complete le hamburger existant (qui
// garde tout le reste : Reglages, Variantes perso, Vue par rarete...) avec
// un acces pouce aux fonctions principales.
export const BottomNavBar = ({ activeKey, onHome, onMenu, onBrowse, onPokedex, onScan }) => {
  // Le scanner (camera native) n'a de sens que dans l'app packagee : le SITE
  // n'est jamais amene a l'utiliser (demande explicite), et sur web la seule
  // "camera" disponible passe par un repli PWA peu fiable (pas de vraie prise
  // de vue possible en HTTP simple, cf. contexte securise exige par les
  // navigateurs). Masque entierement hors app native plutot que d'afficher un
  // bouton qui ne peut pas marcher.
  const isNative = Capacitor.isNativePlatform();
  const items = [
    { key: "home", icon: Home, label: "Accueil", onClick: onHome },
    // Le tiroir (blocs + toutes les autres vues) est la destination la plus
    // frequente : au pouce plutot qu'au hamburger, en haut a gauche.
    { key: "menu", icon: PanelLeft, label: "Blocs", onClick: onMenu },
  ];
  const itemsRight = [
    { key: "browse", icon: Compass, label: "Explorer", onClick: onBrowse },
    { key: "pokedex", icon: BookOpen, label: "Pokédex", onClick: onPokedex },
  ];

  const renderItem = ({ key, icon: Icon, label, onClick }) => (
    <button
      key={key}
      className={`bottom-nav-btn ${activeKey === key ? "active" : ""}`}
      onClick={onClick}
    >
      <Icon className="w-5 h-5" />
      <span>{label}</span>
    </button>
  );

  return (
    <nav className="bottom-nav-bar">
      {items.map(renderItem)}

      {isNative && (
        <div className="bottom-nav-scanner-slot">
          <button className="bottom-nav-scanner-btn" title="Scanner une carte" onClick={onScan}>
            <Camera className="w-6 h-6" />
          </button>
        </div>
      )}

      {itemsRight.map(renderItem)}
    </nav>
  );
};
